<template>
  <a-modal
    :title="title"
    :width="600"
    :visible="visible"
    centered
    :maskClosable="false"
    :destroyOnClose="true"
    :forceRender="true"
    @ok="handleSubmit"
    @cancel="handleCancel()"
    :confirmLoading="confirmLoading"
  >
    <a-spin :spinning="confirmLoading">
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        @submit="handleSubmit"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-form-model-item label="宿舍名称" prop="name">
          <a-input v-model="form.name" placeholder="请输入宿舍名称" />
        </a-form-model-item>
        <a-form-model-item label="就寝时间" prop="bedtime">
          <a-time-picker
            v-model="form.bedtime"
            use24-hours
            format="hh:mm"
            placeholder="就寝时间"
          />
        </a-form-model-item>
        <a-form-model-item label="状态" prop="status">
          <a-radio-group v-model="form.status" button-style="solid">
            <a-radio-button
              :value="item.value"
              v-for="(item, index) in statusList"
              :key="index"
            >
              {{ item.label }}
            </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
import { Dormitory } from "@/api";
import moment from "moment";
export default {
  components: {},
  data() {
    return {
      title: "",
      type: "",
      confirmLoading: false,
      visible: false,
      formData: {
        name: "",
        status: "1",
        schoolId: "",
      },
      form: {},
      monthFormat: "hh:mm",
      statusList: [],
      rules: {
        name: [
          {
            required: true,
            message: "请输入教师名称!",
            trigger: "change",
          },
        ],
        bedtime: [
          {
            required: true,
            message: "请选择就寝时间!",
            trigger: "change",
          },
        ],
        status: [
          {
            required: true,
            message: "请选择状态!",
            trigger: "change",
          },
        ],
      },
    };
  },
  mounted() {},
  created() {},
  methods: {
    moment,
    async open(type, data) {
      this.type = type;
      this.title = type == "edit" ? "编辑宿舍" : "添加宿舍";
      this.visible = true;
      this.form = JSON.parse(JSON.stringify(this.formData));
      if (type == "edit" && data) {
        this.form = JSON.parse(JSON.stringify(data));
        this.form.status = data.status + "";
        this.form.bedtime = data.bedtime
          ? moment(data.bedtime, this.monthFormat)
          : null;
        delete this.form.createTime;
        delete this.form.updateTime;
      }
      // 获取数据字典
      this.statusList = await this.common.getSysCodeType("SYS_STATUS");
    },
    handleSubmit() {
      console.log(this.form);
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let newForm = JSON.parse(JSON.stringify(this.form));
          newForm.schoolId = this.$store.state.user.schoolId;
          if (this.type == "add") {
            delete newForm.id;
          }
          newForm.bedtime = this.moment(newForm.bedtime).format(
            this.monthFormat
          );
          this.submitSave(newForm);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    onChange(time, timeString) {
      console.log(time, timeString);
    },
    // 提交
    submitSave(data) {
      this.confirmLoading = true;
      Dormitory.schoolDormitorySave(data).then(res => {
        if (res.code == this.config.pubCode) {
          this.pubMsg.tipMessage(
            this.type == "edit" ? "修改成功！" : "添加成功！",
            "success"
          );
          this.handleCancel(1);
        }
        this.confirmLoading = false;
      });
    },
    handleCancel(data) {
      this.$emit("ok", data);
      this.visible = false;
      this.$refs.ruleForm.resetFields();
      this.form = JSON.parse(JSON.stringify(this.formData));
    },
  },
};
</script>
